<!-- 
  Component qui sert à afficher du texte directement sur le tableau du braistormin
-->

<template>
  <!-- Container SVG Global -->
  <g
    ref="container"
    :id="'container'+textObj.id"
    :fill="textObj.attributes.color"
    @dblclick.prevent="switchEdit"
    v-touch:longtap="()=>{switchEdit()}"
    :transform="`translate(${textObj.attributes.position.x},${textObj.attributes.position.y})`"
  >
    <!-- Texte affiché par défault -->
    <text
      v-if="!editing"
      @click.self.left.ctrl.exact="select"
      @click.self.left.exact="defaultClickHandler"
      @click.right.self.prevent.exact="test"
      :id="textObj.id"
      :fill="textObj.attributes.color"
      :font-size="textObj.attributes.text ? textObj.attributes.width * 2:textObj.attributes.width * 2"
      :opacity="hasFilteredColor ? /**/   hasFilteredColor === textObj.attributes.color ? '1':'0.2'/**/:'1'"
    >
      {{textObj.attributes.text}}
    </text>
    <!-- Container mode édit activé-->
    <g v-show='editing'>

      <!-- poignée de déplacement du texte -->
      <g
        :transform="`translate(${textArea ?((( textArea.value.length) * parseInt(textObj.attributes.width) *1.2) + 10) /2: 0},-35) scale(0.5,0.5)`"
        id="layer1"
        @mousedown.exact.stop="startMove"
        v-touch:moving="startMove"
        style="display:inline;opacity:1;cursor:grab"
      >
        <path
          style="opacity:1;fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:1.06500006;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
          d="m 11.492589,24.093322 c 0,50.648809 0,50.648809 0,50.648809"
          id="path817"
        />
        <g id="layer2">
          <circle
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke:#7b7b7b;stroke-width:1.34129286;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            id="path815"
            cx="11.492589"
            cy="20.91058"
            r="9.3293533"
          />
        </g>
      </g>

      <!-- Passage en html classique -->
      <foreignObject
        style="text-align:left;overflow: visible;"
        :x="0"
        :y="0"
        :width=" textArea ? (( textArea.value.length) * parseInt(textObj.attributes.width) * 2) : 0"
        :height=" height+10"
      >
        <!-- Input enregistre new text -->
        <input
          @input="changeLengthOfTextArea()"
          type="text"
          rows="1"
          :size="textArea ? (( lengthOfTextArea)  ) : 0"
          @click.self.prevent="textArea.focus()"
          @keypress.enter="validateText"
          :id="`editText${textObj.id}`"
          ref="input"
          :style="`caret-color: black;color:${textObj.attributes.color};font-size:${parseInt(textObj.attributes.width)*2}px;background-color:#00000032; border: none; outline: none;text-align:left;width:${textArea ? (( textArea.value.length) * parseInt(textObj.attributes.width) *1.2) + 10 : 0}px;max-height: ${(parseInt(textObj.attributes.width) + 5) * 2}px;`"
        />
      </foreignObject>
    </g>
    <!-- Bordure de sélection -->
    <g v-show="selected">
      <rect
        :x="-1"
        :y="-17"
        :width="width"
        :height="height"
        fill="none"
        stroke="#ffa500"
        stroke-width="1.5"
      />
    </g>
  </g>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
import debounce from 'lodash.debounce'

export default {
  data () {
    return {
      editing: false,
      moving: false,
      selected: false,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      textArea: undefined,
      lengthOfTextArea: 0
    }
  },
  props: {
    hasFilteredColor: String,
    text: String,
    textObj: Object
  },
  name: 'TextSvg',
  created () {
    setTimeout(() => {
      this.textArea = document.querySelector(`#editText${this.textObj.id}`)
      let square = document.querySelector(`#container${this.textObj.id}`).getBoundingClientRect()
      let svgBoard = document.querySelector('#svgBoard').getBoundingClientRect()
      // console.log(svgBoard)

      this.x = square.x - svgBoard.x
      this.y = square.y - svgBoard.y
      this.width = square.width
      this.height = square.height

      // console.log(this.x, this.y)

      this.$on('stopEditingText', this.disableEditing) // Ecouteur de l'event 'stopEditingText', active la fonction 'disableEditing'
    }, 500)
  },
  updated () {
    debounce(() => {
      this.textArea = document.querySelector(`#editText${this.textObj.id}`)
      let square = document.querySelector(`#container${this.textObj.id}`).getBoundingClientRect()
      let svgBoard = document.querySelector('#svgBoard').getBoundingClientRect()
      // console.log(svgBoard)

      this.x = square.x - svgBoard.x
      this.y = square.y - svgBoard.y
      this.width = square.width
      this.height = square.height

      // console.log(this.x, this.y)
    }, 200)
  },

  computed: {
    ...mapState({
      current: 'current',
      currentSheet: 'currentSheet',
      menu: 'menu'
    })
  },
  methods: {
    startMove (evt) {
      if ( // Check si réunion libre ou si animateur
        (this.$store.state.board.current.mode === 'libre' ||
          this.$router.currentRoute.name === 'animer')
        // eslint-disable-next-line eqeqeq
      ) {
        // console.log(evt)
        // Copie de la vieille fonction de déplacement d'un postit, adaptée à ce component. À refactoriser avec Interact.js
        const elem = evt.currentTarget.closest('svg')

        const getPos = this.getMousePos

        this.moving = true
        // const point = elem.createSVGPoint()
        const updateFn = () => {
          if (this.moving) requestAnimationFrame(updateFn)
        }
        const events = {
          move: 'mousemove',
          stop: 'mouseup'
        }
        const moveFn = evt => {
          getPos(evt, this)
          if (this.selected) {
            let movedDist = this.getDistMoved()
            if (movedDist) {
              movedDist.id = this.id
              this.$emit('moving', movedDist)
            }
          }
          if (this.textObj.attributes.position.x < 0) {
            this.textObj.attributes.position.x = 0
          }
          if (this.textObj.attributes.position.x + 250 > 3840) {
            this.textObj.attributes.position.x = 3840 - 250
          }
          if (this.textObj.attributes.position.y < 0) {
            this.textObj.attributes.position.y = 0
          }
          if (this.textObj.attributes.position.y + 60 > 2160) {
            this.textObj.attributes.position.y = 2160 - 60
          }
        }
        const stopFn = evt => {
          // console.log('stopped', evt)

          if (this.selected) {
            this.$emit('stopped')
          } else {

          }
          this.moving = false

          elem.removeEventListener(events.move, moveFn)
          // console.log('removing eventlistener moveFn')
          elem.removeEventListener(events.stop, stopFn)
          // console.log('removing eventlistener stopFn')
        }

        requestAnimationFrame(updateFn)
        moveFn(evt)

        elem.addEventListener(events.move, moveFn)
        // console.log('adding eventlistener moveFn')

        elem.addEventListener(events.stop, stopFn)
        // console.log('adding eventlistener stopFn')
      }
    },

    getMousePos (mouseEvent, point) {
      this.clientX = mouseEvent.clientX
      this.clientY = mouseEvent.clientY - this.$parent.getHeightOffset() + 143
      // console.log(this.$parent.getHeightOffset())

      var posX = this.clientX - ((((this.textArea.value.length) * parseInt(this.textObj.attributes.width) * 1.2) + 18) / 2) // - this.$parent.getWidthOffset()
      var posY = this.clientY - 38 // - this.$parent.getHeightOffset()
      // console.log('posX :', posX, ' ,posY :', posY)

      this.textObj.attributes.position.x = posX
      this.textObj.attributes.position.y = posY - 80
      this.$refs.container.attributes.transform.value = `translate(${this.textObj.attributes.position.x},${this.textObj.attributes.position.y})`
    },
    test (e) {
      console.log(e)
    },
    changeLengthOfTextArea () {
      this.lengthOfTextArea = this.textArea.value.length
    },
    disableEditing (id) { // Fonction qui désactive le mode édition, reçoit un id de l'event
      if (id !== this.textObj.id) { // si id différent de celui de l'object actuel
        this.editing = false // on désatcive le mode édition
      }
    },

    async modifyShape (shape) {
      const res = await fetch(
        `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape/${this.textObj.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            urlparticipant: this.current.url_participant
          },
          body: JSON.stringify(shape)
        }
      )
      let jsonTest = await res.json()
    },
    validateText (e) {
      let text = e.target.value
      let position = {
        x: this.textObj.attributes.position.x,
        y: this.textObj.attributes.position.y
      }

      let width = this.textObj.attributes.width
      let color = this.textObj.attributes.color
      // Format data for DB storage
      let svgpath = {
        attributs: {
          text: text,
          position: position,
          width: width,
          color: color
        }
      }
      let pathTxt = {
        svgpath: svgpath,
        attributes: svgpath.attributs,
        sheet: this.currentSheet,
        name: 'text' + this.currentSheet
      }
      // If there is text, send it to the DB and reset everything
      if (text !== null && text !== undefined) {
        this.modifyShape(pathTxt)
      }
      this.textArea.value = null
      this.editing = false
    },
    select (e) {
      this.selected = !this.selected
      if (this.selected) {
        this.$parent.selectedSvgs.push(this.textObj.id)
      } else {
        this.$parent.selectedSvgs = this.$parent.selectedSvgs.filter(svg => svg !== this.textObj.id)
      }
      // console.log(this.$parent.selectedSvgs)
    },
    switchEdit (e) { // Fonciton qui gere le toggle du  mode édition
      this.editing = !this.editing //inverse le mode édition
      this.$store.commit('board/ETAT_MENU', '') // cache le menu du click-droit
      if (this.editing) { // si on vient d'activer le mode édition
        this.textArea.value = this.text // on met la valeur du texte dans la textArea
        this.$emit('stopEditingText', this.textObj.id) // on désactive le mode édition de tous les autres components
        setTimeout(() => {
          this.textArea.select() // on surligne le texte à l'intérieur de la textArea
        }, 50)
      } else { // Si on vient de désactiver le mode édition
        this.validateText(e) // on valide le contenu de la textArea
      }
      setTimeout(() => {
        this.textArea.focus() // on focus la textArea
      }, 200)
    },
    defaultClickHandler (e) { // gestion du click sur le component
      if (this.menu.erasing) { // si on est en mode suppression
        this.clean(e) // active la fonction effacer le component
      }
    },
    async clean (e) {
      // Check for autorizations
      if (
        this.menu.erasing &&
        e.target.id !== 'svgBoard' &&
        e.target.attributes.opacity.value === '1'
      ) {
        // Sends the delete action to the backend
        let res = await fetch(
          `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape/${e.target.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              urlparticipant: this.current.url_participant
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>
#editText {
  background-color: #00000033;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/board/TextSvg.vue